import { Route } from "@/model/route.model";
import { StudioService } from "../studio.interface";
import { Location } from "@/model/location.model";
import { DEFAULT_IMG } from "@/constants";

export class StudioServiceBackend implements StudioService {    

    
    // eslint-disable-next-line max-len
    private static readonly USER_TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjQ1MTQxLCJyb2xlIjotMSwiaWF0IjoxNzMyNjA0NzMzfQ.L0HUqSje65va049c6H6Y2UI77cP9DxexxHPbkjOFnoU";
    private static readonly HOST = "https://studio.onirix.com";
    private static readonly PLAYER_HOST = "https://player.onirix.com"

    private static readonly ROUTE_DATASHEET = "ox-route";
    private static readonly LOCATION_DATASHEET = "ox-route__location";

    public async getRouters(): Promise<Route[]> {
        const baseUrl = StudioServiceBackend.HOST + "/api/projects";
        const url = new URL(baseUrl);
        url.searchParams.append("withDatasheets", "true");
        const projects = await fetch(url.toString(), {
            headers: {
                "Authorization": `Bearer ${StudioServiceBackend.USER_TOKEN}`
            }
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText);
                }
                return response.json();
            })
            .then(data => {
                return data.data.filter(p => p.datasheets.
                    find(ds => ds.template.name == StudioServiceBackend.ROUTE_DATASHEET))
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
            });
        return this.normalizeProjectsData(projects);

    }

    private normalizeProjectsData(projects): Route[] {
        const routes = [];
        projects?.forEach(p => {
            const dsData = p.datasheets.find(ds => ds.template.name == StudioServiceBackend.ROUTE_DATASHEET);
            const locationsDS = p.datasheets.filter(ds => ds.template.name == StudioServiceBackend.LOCATION_DATASHEET);
            const locations = this.normalizeLocations(locationsDS);
            const route: Route = {
                name: dsData.content[0].name,
                address: dsData.content[1].address,
                image: this.getImage(dsData.content[2].image),
                description: dsData.content[3].description,
                url: `${StudioServiceBackend.PLAYER_HOST}/projects/${p.oid}/webar?` +
                `token=${p.publicToken}&background=${p.embedSettings.canvas_background}&` +
                `preview=${p.embedSettings.force_preview}&hide_controls=${p.embedSettings.hide_controls}&` +
                `ar_button=${p.embedSettings.ar_button}`,
                locations: locations,
                map: this.getImage(dsData.content[4].map),
                description_district: dsData.content[5].description_district,
                ref: dsData.content[6].ref,
                directions: dsData.content[7].directions,
                token: p.publicToken
            };
            routes.push(route);
        });
        return routes.sort((a, b) => a.ref - b.ref);
    }

    private normalizeLocations(datasheets): Location[] {
        const locations = [];
        datasheets?.forEach(ds => {
            const location: Location = {
                name: ds.content[0].name,
                image: this.getImage(ds.content[1].image),
                author: ds.content[2].author,
                image_ant: this.getImage(ds.content[3].image_ant, false),
                author_ant: ds.content[4].author_ant,
                description: ds.content[5].description,
                address: ds.content[6].address,
                quiz: ds.content[7].quiz,
                long: ds.content[8].long,
                lat: ds.content[9].lat,
                ar: ds.content[10].ar,
                oid: ds.content[11].sceneOid
            };
            locations.push(location);
        });
        return locations;
    }

    public getImage(oid: string, force = true): string {
        if (oid == "" && force) {
            oid = DEFAULT_IMG;
        } else if (oid == "" && !force) {
            return "";
        }
        return `${StudioServiceBackend.HOST}/api/assets/${oid}/thumb?token=${StudioServiceBackend.USER_TOKEN}`;
    }

    public async addNewView(oid: string, token: string): Promise<void> {
        const baseUrl = StudioServiceBackend.HOST + "/api/targets/" + oid;
        const url = new URL(baseUrl);
        await fetch(url.toString(), {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText);
                }

            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
            });
    }
    
}